import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { Box, Typography, Button, Link } from "@mui/material"
import { colors } from "@parallel-domain/pd-theme"
import { usePrivacyConsent } from "../hooks/usePrivacyConsent"

const PrivacyBanner = () => {
  const { showBanner, onOptIn, onOptOut } = usePrivacyConsent()

  if (!showBanner) {
    return null
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: colors.secondary[800],
        padding: 2,
        boxShadow: 3,
        zIndex: 1000,
        borderTop: `1px solid ${colors.border[800]}`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 1, md: 4 },
        }}
      >
        <Typography variant="body2" sx={{ mb: 1 }}>
          We and our vendors use technology that collects or records personal
          information about your use of our site so we can improve and
          personalize our products and services, for analytics and marketing,
          and to fulfill your requests. We may also share this information with
          marketing vendors, social media companies, and analytics partners.{" "}
          <Link to="/privacy-policy" color="primary" component={GatsbyLink}>
            Privacy Policy
          </Link>
          . By using our website, you acknowledge and agree to our{" "}
          <Link to="/terms-of-use" color="primary" component={GatsbyLink}>
            Terms of Use
          </Link>
          .
        </Typography>

        <Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button variant="text" size="small" onClick={onOptOut}>
              Deny
            </Button>
            <Button variant="contained" size="small" onClick={onOptIn}>
              Accept
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PrivacyBanner
